// extracted by mini-css-extract-plugin
export default {"list":"InputsWrapper_list__pFWv5","margin":"InputsWrapper_margin__dIyvd"};